import type { RateCard } from '@/models/rateCard';
import { DEFAULT_CURRENCY } from '@/constants/currency';

/** Coerce API/Mongo values (number or numeric string) for InputNumber fields. */
export const toFormNumber = (value: unknown): number | undefined => {
  if (value === null || value === undefined || value === '') {
    return undefined;
  }
  const parsed = typeof value === 'number' ? value : Number(value);
  return Number.isFinite(parsed) ? parsed : undefined;
};

/** Map a rate card row to form field values for edit/create. */
export const toRateCardFormValues = (record: Partial<RateCard>): Partial<RateCard> => ({
  channel: record.channel,
  product: record.product,
  tactic: record.tactic,
  monthlySpent: toFormNumber(record.monthlySpent),
  buyingMetric: record.buyingMetric,
  currency: record.currency ?? DEFAULT_CURRENCY,
  buyRate: toFormNumber(record.buyRate),
  sellRate: toFormNumber(record.sellRate),
  kpis: record.kpis ?? [],
  benchmark: toFormNumber(record.benchmark),
  formats: record.formats ?? [],
  cost: record.cost ?? false,
  costsFee: toFormNumber(record.costsFee),
  notes: record.notes
});
